import Api2Talk from "../../services/api2talk";
import Api from "../../services/api";
import { PapiroConsole } from "../../utils/papiroConsole";

// --- Criar chamado a partir do chat ATIVO (chamado = domínio do FieldService → usa Api) ---

// Normaliza o JSON lowercase do backend (LowercaseContractResolver) para camelCase.
export const normalizeLinkedCalled = (c) => ({
	id: c.id,
	calledId: c.calledid ?? c.calledId,
	chatId: c.chatid ?? c.chatId,
	createdAt: c.createdat ?? c.createdAt,
	isLatest: c.islatest ?? c.isLatest ?? false,
	assignedUserId: c.assigneduserid ?? c.assignedUserId ?? c.assigned_user_id ?? null,
});

// PUT /calleds/startattendance — o técnico logado assume o chamado (mesmo endpoint da "Minha Pauta":
// faz AssumeCalled + grava histórico + status). Reuso total, sem endpoint novo.
export const selfAssignCalled = async (calledId, userId) => {
	let data;
	const form = new FormData();
	form.append("calledid", calledId);
	form.append("userid", userId);
	await Api.put("/calleds/startattendance", form)
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err;
		});
	return data;
}

// POST /called-from-active-chat/create — backend decide sync/async pela env var.
// Resposta (sync): { success, data: { calledid, title, createdat, pending:false } }
//          (async): { success, data: { pending:true } }
export const createCalledFromChat = async (post) => {
	let data;
	await Api.post("/called-from-active-chat/create", post)
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err;
		});
	return data;
}

// GET /called-from-active-chat/bychat/{chatId} — lista vinculados (mais novo → antigo).
export const getLinkedCalledsByChatId = async (chatId) => {
	let data;
	await Api.get(`/called-from-active-chat/bychat/${chatId}`)
		.then(result => {
			if (result.data && result.data.success && Array.isArray(result.data.data)) {
				result.data.data = result.data.data.map(normalizeLinkedCalled);
			}
			data = result.data;
		})
		.catch(err => {
			data = err;
		});
	return data;
}

// Normaliza a tag da conversa (API serializa lowercase: id/name).
export const normalizeChatTag = (t) => ({
	id: t.id ?? t.Id,
	name: t.name ?? t.Name
});

// GET /chat/{chatId}/tags — tags (chips read-only) da conversa, pra sidebar de informações.
export const getChatTags = async (chatId) => {
	let data;
	await Api2Talk.get(`/chat/${chatId}/tags`)
		.then(result => {
			if (result.data && result.data.success && Array.isArray(result.data.data)) {
				result.data.data = result.data.data.map(normalizeChatTag);
			}
			data = result.data;
		})
		.catch(err => {
			data = err;
		});
	return data;
}

// POST /chat/{chatId}/tags — classifica a conversa: adiciona tag por nome (find-or-create no backend).
export const addChatTag = async (chatId, name) => {
	let data;
	await Api2Talk.post(`/chat/${chatId}/tags`, { name })
		.then(result => { data = result.data; })
		.catch(err => { data = err; });
	return data;
}

// DELETE /chat/{chatId}/tags/{tagId} — remove (soft-delete) o vínculo da tag com a conversa.
export const removeChatTag = async (chatId, tagId) => {
	let data;
	await Api2Talk.delete(`/chat/${chatId}/tags/${tagId}`)
		.then(result => { data = result.data; })
		.catch(err => { data = err; });
	return data;
}

export const getChannelFromTechinicalTeam = async (id) => {
	let data;
	await Api2Talk.get(`/channel/techinicalteam/${id}`)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getTechinicalTeamFromUser = async (id) => {
	let data;
	await Api2Talk.get(`/techinicalteam/user/${id}`)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getTechList = async (chatid, channelid, techinicalteamid) => {
	let data;
	await Api2Talk.get(`/channeltechinicalteam/getusers/${chatid}/${channelid}/${techinicalteamid}`)
		.then(result => {
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getProviderList = async () => {
	let data;
	await Api2Talk.get("/messageprovider")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getStatusList = async () => {
	let data;
	await Api2Talk.get("/chatstatus")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name,
						colorhex : item.colorhex
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getChatClosingStatus = async () => {
	let data;
	await Api2Talk.get("/chatclosingstatus")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name,
						resolved : item.resolved
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getChannelList = async () => {
	let data;
	await Api2Talk.get("/channel")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				var formatlist = result.data.data.map(item => {
					return {
						id: item.id,
						name: item.name
					}
				})
				result.data.data=formatlist;
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const sendMessage = async (post) => {
	let data;
	//alert(JSON.stringify(post));
	await Api2Talk.post("/messenger/send",post)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const sendMessageAttachment = async (post, config) => {
	let data;
	//alert(JSON.stringify(post));
	await Api2Talk.post("/messenger/send/attachment", post, config)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}
export const sendMessageAudio = async (post, config) => {
	let data;
	//alert(JSON.stringify(post));
	await Api2Talk.post("/messenger/send/audio", post, config)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}
export const reSendMessage = async (post) => {
	let data;
	//alert(JSON.stringify(post));
	await Api2Talk.post("/messenger/resend",post)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const newConversationModal = async (data) => {
	
	//alert(JSON.stringify(post));
	await Api2Talk.post("/chat/new-conversation",data)
		.then(result => {
			if (result.data.success) {
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


// Disparo de mensagem ATIVA via provedor (WhatsApp) a partir da conversa. Reusa o MESMO endpoint
// desacoplado (optin + strategy WhatsApp) usado pela ação de automação "Disparar mensagem via provedor".
// payload: { registrationNumberRequestId, templateMessageId, recipients:[{phoneNumber,userId?,label?}],
//            headerVariableValues, bodyVariableValues, buttonVariableValues, recipientUserIdReference? }
export const dispatchActiveMessage = async (data) => {
	await Api2Talk.post("/chat/dispatch-active-message", data)
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err;
		});
	return data;
}


export const validatePhone = async (data) => {

	//alert(JSON.stringify(post));
	await Api2Talk.post("/chat/validate-phone",data)
		.then(result => {
			if (result.data.success) {
				data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const  GetChatList = async (id, filterid, filterchatid) => {
	let data;
	let url = "/chat";
	if(id != null){
		url=url+"/"+id;
	}
	if(filterid && filterchatid ){
		url=url+`?filterid=${filterid}&filterChatId=${filterchatid}`;
	}
	
	

	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {

			  data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getChatsWithoutChannel = async () => {
	let data;
	await Api2Talk.get("/chat/without-channel")
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const associateWithoutChannelChat = async (chatId, channelId) => {
	let data;
	await Api2Talk.put(`/chat/without-channel/${chatId}/channel`, { channelid: channelId })
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const associateAllWithoutChannelChats = async (registrationNumberRequestId, channelId) => {
	let data;
	await Api2Talk.put(
		`/chat/without-channel/registration-number/${registrationNumberRequestId}/channel`,
		{ channelid: channelId }
	)
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const getTeamMismatchChats = async () => {
	let data;
	await Api2Talk.get("/chat/team-mismatch")
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const repairTeamMismatchChat = async (chatId) => {
	let data;
	await Api2Talk.put(`/chat/team-mismatch/${chatId}/repair`, {})
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const repairAllTeamMismatchChats = async (registrationNumberRequestId) => {
	let data;
	await Api2Talk.put(`/chat/team-mismatch/registration-number/${registrationNumberRequestId}/repair`, {})
		.then(result => {
			data = result.data;
		})
		.catch(err => {
			data = err.response?.data || err;
		});
	return data;
}

export const  getChatIndicators = async ( filterid, filterchatid) => {
	let data;
	let url = "/chat/indicators";
	
	if(filterid && filterchatid ){
		url=url+`?filterid=${filterid}&filterChatId=${filterchatid}`;
	}
	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {

			  data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const GetChatListByTech = async (id, page = 1, filters = null) => {
	let data;
	let url = "/chat/technician";
	if(id != null){
		url=url+"/"+id;
	}
	if(page!= null){
		url=url+`?page=${page}`;
	}
	if(filters){
		url=url+`?title=${filters.title}&status=${filters.status}&techinicalteam=${filters.techinicalteam}&channel=${filters.channel}&origin=${filters.origin}`;
	}
	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {

			  data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const GetHistoryChatListByCustomer = async (customerid, chatid) => {
	let data;
	let url = "/chat/history";
	
	
	url=url+`?customerid=${customerid}&chatid=${chatid}`;
	
	
	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {

			  data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const GetChatToObserve= async (id, page = 1) => {
	let data;
	let url = "/chat/technician/observe";
	if(id != null){
		url=url+"/"+id;
	}
	if(page!= null){
		url=url+`?page=${page}`;
	}
	
	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {

			  data= result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const GetImageMeta = async (id) => {
	let data;
	let url = "/messenger/image/"+id;
	await Api2Talk.get(url)
		.then(result => {
			if (result.data.success) {
           
			  data= result.data;
			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}


export const getUserStatusList = async () => {
	let data;
	await Api2Talk.get("/userstatus")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				data = result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getModalOptions = async () => {
	let data;
	await Api2Talk.get("/chat/getmodaloptions")
		.then(result => {
			
			if (result.data.success) {

				data = result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getEnabledUsers = async () => {
	let data;
	await Api2Talk.get("/enableusers/getall")
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {
				data = result.data;
			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}

export const getEnabledUserById = async (id) => {
	let data;
	PapiroConsole.log(id)
	PapiroConsole.log("id 2 ")
	await Api2Talk.get(`/enableusers/userid/${id}`)
		.then(result => {
			//console.error('RESULTT0');
			//console.error(result);
			if (result.data.success) {

				data = result.data;

			} else {
				data= result.data;
			}
		})
		.catch(err => {
			data=err;
		 
		});
	return data;
}
